import { 
  GoogleAuthProvider, 
  signInWithPopup, 
  signInWithRedirect, 
  getRedirectResult, 
  createUserWithEmailAndPassword, 
  signInWithEmailLink,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailAndPassword
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from './firebaseConfig';

// Register User with Email & Password
export async function registerUser(email, password, additionalInfo = {}) {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    console.log("User created:", user.uid);

    await setDoc(doc(db, "users", user.uid), {
      email: user.email,
      createdAt: new Date(),
      ...additionalInfo
    });

    console.log("User registered successfully in Firestore");
    return { success: true, user: user };
  } catch (error) {
    console.error("Error registering user:", error.code, error.message);
    return { success: false, error: error.message };
  }
}

export async function signInWithGoogle(forceLogin = false) {
  try {
    const provider = new GoogleAuthProvider();
    
    // Only force login if explicitly requested
    if (forceLogin) {
      provider.setCustomParameters({ prompt: "consent" });
    } else {
      provider.setCustomParameters({ prompt: "select_account" });
    }

    // If user is already signed in, return their details
    if (!forceLogin && auth.currentUser) {
      console.log("User already signed in:", auth.currentUser);
      return { success: true, user: auth.currentUser };
    }

    const result = await signInWithPopup(auth, provider);
    console.log("Google Sign-in Success:", result.user);
    return { success: true, user: result.user };
  } catch (error) {
    console.error("Google Sign-in Error:", error.code, error.message);

    // Handle popup issues by falling back to redirect authentication
    if (error.code === 'auth/popup-blocked' || error.code === 'auth/cancelled-popup-request') {
      console.warn("Popup blocked or canceled. Trying redirect authentication...");
      const provider = new GoogleAuthProvider(); // Ensure provider is defined
      signInWithRedirect(auth, provider);
      return { success: false, error: "Popup blocked. Redirecting..." };
    }

    return { success: false, error: error.message };
  }
}

// Email Link Configuration
const actionCodeSettings = {
  url: window.location.origin + '/login/confirm',
  handleCodeInApp: true,
};

// Send Sign-In Link to Email
export async function sendMagicLink(email) {
  try {
    await sendSignInLinkToEmail(auth, email, actionCodeSettings);
    window.localStorage.setItem("emailForSignIn", email);
    console.log("Sign-in link sent to:", email);
    return { success: true, message: "Sign-in link sent! Check your email." };
  } catch (error) {
    console.error("Error sending sign-in link:", error);
    return { success: false, error: error.message };
  }
}

// Complete Sign-In with Email Link
export async function completeMagicSignIn() {
  try {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let email = window.localStorage.getItem("emailForSignIn");
      if (!email) {
        email = window.prompt("Please enter your email for verification:");
      }
      const result = await signInWithEmailLink(auth, email, window.location.href);
      console.log("Email link sign-in successful:", result.user);
      window.localStorage.removeItem("emailForSignIn");
      return { success: true, user: result.user };
    }
    return { success: false, error: "Not a valid sign-in link" };
  } catch (error) {
    console.error("Email link sign-in error:", error);
    return { success: false, error: error.message };
  }
}

// Login with Email and Password
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
